<mat-form-field floatLabel="always" appearance="outline" class="w100">
<div class="posr">
    <mat-icon class="mat-18 pointer"
              (click)="dropAll($event)">close
    </mat-icon>
</div>
  <mat-label>{{field.templateOptions.placeholder}}</mat-label>
<input matInput
       [id]="myId"
       #trigger="matAutocompleteTrigger"
       [matAutocomplete]="auto"
       [formControl]="formControl"
       [formlyAttributes]="field">

<mat-autocomplete
        (click)="openPanel($event)"
        #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let item of filter | async" [value]="item">
        {{ item.label }}
    </mat-option>
</mat-autocomplete>
</mat-form-field>



